/** Selecție multiplă de produse pentru admin (click dreapta → mutare în altă categorie). */
const listeners = new Set();
const selected = new Map(); // id -> name

export const isAdminUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    return !!localStorage.getItem('token') && (user?.role === 'admin' || user?.isAdmin === true);
  } catch { return false; }
};

const notify = () => listeners.forEach((cb) => cb(new Map(selected)));

export const subscribeSelection = (cb) => {
  listeners.add(cb);
  cb(new Map(selected));
  return () => listeners.delete(cb);
};

export const toggleSelection = (id, name) => {
  if (selected.has(id)) selected.delete(id);
  else selected.set(id, name || '');
  notify();
};

export const clearSelection = () => {
  selected.clear();
  notify();
};

export const getSelection = () => new Map(selected);
